import { Component, Input } from '@angular/core';
import {
    BookingSummary,
    BookingSummaryResult,
    BookingStatus
} from "models";

@Component({
    selector: 'app-booking-metrics',
    template: require('./booking-metrics.component.html'),
    styles: [require('./booking-metrics.component.scss')]
})

export class BookingMetricsComponent {
    @Input()
    get bookingSummary(): BookingSummary {
        return this.summary;
    }

    set bookingSummary(input: BookingSummary) {
        this.summary = input;
    }

    summary: BookingSummary;

    applyCancelToSummary(item: BookingSummaryResult) {
        if (item.guestBookingStatus === BookingStatus.approved) {
            this.summary.approved--;
        }

        if (item.guestBookingStatus === BookingStatus.notApproved) {
            this.summary.notApproved--;
        }

        this.summary.cancelled++;
    }
}